<app-supplier-dc-brand-filter
  #suppierDcBrandFilter
  (filterChanged)="onSupplierDcBrandChanged($event)"
>
</app-supplier-dc-brand-filter>

<div class="container">
  <div class="row mb-3">
    <div class="col-sm-12">
      <div class="d-flex">
        <kendo-label>Retailer Parent</kendo-label>
        <div class="ms-auto">
          <app-select-all
            (clicked)="selectAllRetailerParents()"
          ></app-select-all>
        </div>
      </div>
      <kendo-multiselect
        name="select-parents"
        id="select-parents"
        placeholder="Select Retailer Parent"
        [data]="retailerParentOptions"
        valueField="id"
        textField="name"
        [kendoDropDownFilter]="{ operator: 'contains' }"
        [autoClose]="false"
        [(ngModel)]="selectedRetailerParentList"
        [tagMapper]="tagMapper"
        [virtual]="{ itemHeight: 24 }"
        (ngModelChange)="onRetailerParentModelChange()"
      ></kendo-multiselect>
    </div>
  </div>

  <div class="row mb-3">
    <div class="col-sm-12">
      <div class="d-flex">
        <kendo-label>Retailer Area</kendo-label>
        <div class="ms-auto">
          <app-select-all (clicked)="selectAllRetailerAreas()"></app-select-all>
        </div>
      </div>
      <kendo-multiselect
        name="select-chain-group"
        id="select-chain-group"
        placeholder="Select Retailer Area"
        [data]="retailerAreaNameOptions"
        valueField="id"
        textField="name"
        [kendoDropDownFilter]="{ operator: 'contains' }"
        [autoClose]="false"
        [(ngModel)]="selectedRetailerAreaList"
        [tagMapper]="tagMapper"
        [virtual]="{ itemHeight: 24 }"
        (ngModelChange)="onChainGroupSelected()"
        [disabled]="selectedRetailerParentList?.length === 0"
        [loading]="isRetailerAreaNamesLoading$ | async"
      ></kendo-multiselect>
    </div>
  </div>
  <div class="row mb-3">
    <div class="col-sm-12">
      <div class="d-flex">
        <kendo-label>Channel</kendo-label>
        <div class="ms-auto">
          <app-select-all (clicked)="selectAllChannels()"></app-select-all>
        </div>
      </div>
      <kendo-multiselect
        name="select-channels"
        id="select-channels"
        placeholder="Select Channel"
        [data]="channelOptions"
        valueField="value"
        textField="label"
        [kendoDropDownFilter]="{ operator: 'contains' }"
        [autoClose]="false"
        [(ngModel)]="selectedChannelList"
        [tagMapper]="tagMapper"
        [virtual]="{ itemHeight: 24 }"
        (ngModelChange)="onChannelSelected()"
      ></kendo-multiselect>
    </div>
  </div>
</div>
